import React from "react";
import { Navbar } from "../Navbar/Navbar";
import { Link } from "react-router-dom";

function Hiring() {
  return (
    <>
      <Navbar />
      <div className="App">
        <div className="row pb-5 pt-5">
          <h1>Hiring</h1>
        </div>
        <div className="container-fluid">
          <div className="Payment">
            <iframe
              class="clickup-embed clickup-dynamic-height"
              src="https://forms.clickup.com/4546869/f/4ar9n-35535/OBHGFBZP5RBVRMV864"
              onwheel=""
              width="100%"
              height="100%"
              style={{ background: "transparent", border: "1px solid #ccc" }}
            ></iframe>
            <script
              async
              src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
            ></script>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <Link to="/Communication">
              <button className="btn btn-secondary my-4 p-3 ">
                Return Back
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Hiring;
